import _ from 'lodash';
import store from '@/store';

var printerDemoApi = {
  isBluetoothPrinterConnected() {
    return true;
  },
  isLowOnPaperOrNoConnection() {
    return false;
  },
  showSettingsScreen() {
    if (store.state.ShowPrinter) {
      console.info(`showSettingsScreen()`);
    }
    alert('Printer settings demo');
  },
  printLine(str: string) {
    if (!store.state.ShowPrinter) return;
    console.info(`printLine(${str})`);
  },
  printHebrewLine(str: string) {
    if (!store.state.ShowPrinter) return;
    console.info(`printHebrewLine(${str})`);
  },
  lineFeed(n: number) {
    if (!store.state.ShowPrinter) return;
    console.info(`lineFeed(${n})`);
  },
  cutPaper() {
    if (!store.state.ShowPrinter) return;
    console.info(`cutPaper()`);
  },
  printIcon() {
    if (!store.state.ShowPrinter) return;
    console.info(`printIcon()`);
  },
  setDirection(dir: string) {
    if (!store.state.ShowPrinter) return;
    console.info(`setDirection(${dir})`);
  },
};

var printerApi = (window as any).opx__jsprinter || printerDemoApi;

printerApi.YayaPrintLines = function(lines: string[]) {
  var self = this;
  self.setDirection('RIGHT');
  for (var i = 0; i < lines.length; i++) {
    var str = lines[i];
    if (str === '') {
      printerApi.lineFeed(1);
    } else {
      printerApi.printHebrewLine(str);
    }
  }

  self.printIcon();
  self.lineFeed(5);
  self.cutPaper();
};

export default printerApi;
